export default "__VITE_ASSET__BTSZrR_2__"